import { init as initCarousel2 } from './carousel2'
import { init as initCollectionTabs } from './collection-tabs'
import { init as initFeaturedProducts } from './featured-products'
import { init as initPinMap } from './pin-map'

const logErrors = function (err: unknown): void {
  console.error(err)
}

initCollectionTabs().catch(logErrors)
initCarousel2().catch(logErrors)
initFeaturedProducts().catch(logErrors)
initPinMap().catch(logErrors)
